module.exports = __webpack_public_path__ + "img/farfetch.b385b176.svg";